
export const validationRuleConstants = {
  ruleSeverity: {
    error: 'error',
    warning: 'warning'
  },
  editSubmission: {
    // NOTE: all rule names are not specified here, but any rules which have a use case
    // for specific display/handling that cannot otherwise be identified in a more generic
    // manner can be defined here; search the project for usages to see specific cases
    // [Patterson, John - 2017.05.01.14.20]
    ruleNames: {
      salaryRangeMax: 'salaryRangeMax'
    }
  }
};
